import { Button } from "@/components/UI/Button";
import {
  IbaseWidgetDetailsExtended,
  onAddWidget,
  returnCurrentTabID,
  returnCurrentTabStateJSON,
} from "@/lib/widgetHelperFunctions";
import { baseWidgetDetails } from "@/lib/widgetsLayoutDir";
import { updateWorkspaceTabActionUpdate } from "@/store/workspacesTabsStoreACTIONS";
import {
  DRAG_HEADER,
  widgetAcceptsBlockDrop,
  widgetAcceptsESIDDrop,
} from "@/lib/reactGridLayout/dndConstants";
import { DragEndEvent, DragStartEvent } from "@dnd-kit/core";
import { Layouts } from "react-grid-layout";
import { toast } from "react-toastify";
import {
  IActiveId,
  IState,
  IWidgetDetails,
  IWorkspaceTabs,
} from "../widgetsLayoutDir";

// DnD START
// HOW TO ADD a DnD overlay.
// 1. Wrap the desired component (in table renderer for AG Grid) with Draggable.
// 2. Store the ID and header value: eg - <Draggable id={props.data.details} header={"Details"}>
// 3. Find the comment `// DND style for widgets ABOVE` and add the logic to the tailwind based off the header details.

const NoTradeTileToAddMessage = (esidClicked: string) => {
  const tradeTile: IbaseWidgetDetailsExtended | undefined =
    baseWidgetDetails.find((widget) => widget.component == "TradeTile");
  if (tradeTile) {
    tradeTile.esid = esidClicked;

    return (
      <div>
        No trade tile on workspace to drop trade.
        <div>
          <Button
            variant="toastAction"
            onClick={() => {
              if (tradeTile) {
                onAddWidget(tradeTile);
              }
            }}
            className=""
          >
            Add: {esidClicked}
          </Button>
        </div>
      </div>
    );
  }
};

// DND Start - This is used for dragging ESID's or Trade Details off the action summary and dropped onto other widgets in RGL.
export const handleDragStart = ({
  event,
  setActiveId,
  state,
}: {
  event: DragStartEvent;
  setActiveId: Function;
  state: IState;
}) => {
  let tableHeadingDragged = "";

  if (event.active.data.current) {
    tableHeadingDragged = event.active.data.current.header;

    // Only warn when NO widget on the workspace can accept the dragged ESID. Any
    // ESID-accepting widget (Trade Tile OR Swap Curve, per widgetAcceptsESIDDrop) suppresses
    // the toast — the drop has somewhere to land.
    if (event.active.data.current.header == "ESID") {
      const widgetThatAcceptsESID = state.layouts[state.currentBreakpoint].find(
        (widget) => widgetAcceptsESIDDrop(widget.i),
      );
      if (widgetThatAcceptsESID == undefined) {
        toast.warn(NoTradeTileToAddMessage(event.active.data.current.value));
      }
    }

    setActiveId({
      isActive: true,
      value: event.active.data.current.value.toString(),
      headerDragging: tableHeadingDragged, // will be empty string if unknown
      eventOver: "",
      // Optional display text for the overlay; falls back to value when not supplied.
      label: event.active.data.current.label ?? null,
    });
  }
};

export const handleDragEnd = ({
  event,
  activeId,
  setActiveId,
}: {
  event: DragEndEvent;
  activeId: IActiveId;
  setActiveId: Function;
}) => {
  // Handle the logic for updating the layout or other actions
  if (event.over) {
    const overId = event.over.id.toString();

    // ESID dropped onto a trade-accepting widget (Trade Tile, Swap Curve).
    const isESIDDrop =
      activeId.headerDragging == DRAG_HEADER.ESID && widgetAcceptsESIDDrop(overId);

    // Creation block dropped onto a block-accepting widget (Swap Curve).
    const isBlockDrop =
      activeId.headerDragging == DRAG_HEADER.BLOCK && widgetAcceptsBlockDrop(overId);

    if (isESIDDrop || isBlockDrop) {
      setActiveId((prevState: any) => {
        return { ...prevState, eventOver: overId };
      });
    }

    //Need to connect the logic for dropping a price on the Analytics widget.

    // else if (
    //   event.over.id.toString().includes("Analytics") &&
    //   activeId.headerDragging == "Details"
    // ) {
    //   toast(
    //     `ANALYTICS EVENT: Item ${event.active.id} dropped on ${event.over.id}`,
    //   );
    // }
  }
  setTimeout(function () {
    setActiveId({
      isActive: false,
      value: null,
      headerDragging: null,
      eventOver: "",
      label: null,
    });
  }, 50); // Timer to allow the eventOver to be applied in the trade tile before getting set back to ""
};
// DND Start

//
export function updateStateFromStore({
  workspacesTabs,
  setState,
}: {
  workspacesTabs: IWorkspaceTabs[];
  setState: Function;
}) {
  const activeTab = returnCurrentTabID();
  const updatedState = workspacesTabs.find((tab) => tab.tabId == activeTab);

  if (updatedState !== undefined) {
    const parsetoState = JSON.parse(updatedState?.stateJson);
    setState(parsetoState);
  }
}

// THE ONLY UPDATE TO THE DB needs to happen here.
// RGL records a change to the layout state and the db call can be made on this to cater for both adding and deleting data.
export const onLayoutChange = ({
  layouts,
  getAccessTokenSilently,
}: {
  layouts: Layouts;
  getAccessTokenSilently: Function;
}) => {
  const currentTabStateJSON = returnCurrentTabStateJSON();
  updateWorkspaceTabActionUpdate(
    layouts,
    currentTabStateJSON,
    getAccessTokenSilently,
  );
};

export const infoForExpandWidetModal: IWidgetDetails = {
  displayName: "",
  component: "",
  icon: "",
  w: 0,
  h: 0,
  minW: 0,
  minH: 0,
  y: 0,
  x: 0,
  i: "",
};
